import {removeJWTToken} from "../app/utils/getJWTToken";
import {ENV_KEY} from "./env";

/**
 * This service stores and retrieves user preferences in session storage
 */
class AppConfig {
    sort: string;
    emailAddress?: string;
    restDelay: number;
    isAdmin: boolean;
    origin = ENV_KEY;

    constructor() {
        this.sort = '+date';
        this.isAdmin = false;
        this.emailAddress = undefined;
        this.restDelay = 100;
        this.load();
    }

    load () {
        const config = JSON.parse(sessionStorage.getItem(`${ENV_KEY}-appConfig`)!);
        if (!config?.origin || config.origin !== this.origin) {
            removeJWTToken();
            this.save();
        }
        try {
            Object.assign(this, {...config});
        } catch (error) {
            console.log(error);
        }
    }

    save () {
        sessionStorage.setItem(`${ENV_KEY}-appConfig`, JSON.stringify({ ...this }));
    }
}

let instance = new AppConfig();
export default instance;
